import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { ReactComponent as Warning } from '../../../assets/images/icon/warning.svg';
import { BarcodeWithNameFullScreen, SolidBtn } from '../../';

interface IProps {
    isOpen: boolean;
    setIsOpen: Function;
    member?: IMember;
    isError?: boolean;
    hasReservationToday?: boolean;
}

const BarcodeBasicModal = ({ isOpen, setIsOpen, member, isError, hasReservationToday }: IProps) => {
    const navigate = useNavigate();
    const [isOpenBarcodeWithNameFullScreenModal, setIsOpenBarcodeWithNameFullScreenModal] = useState<boolean>(false);

    const maskedMobile = member && (member.mobile.slice(0, 3) + "-" + member.mobile.slice(3, 5) + "**-" + member.mobile.slice(7, 9) + "**");

    const userSection = member && (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
            <div style={{ display: "flex", alignItems: "flex-end", gap: 7 }}>
                <div style={{ fontSize: "24px", fontWeight: "700", lineHeight: "28.64px" }}>
                    {member.name} 님
                </div>
                {member.grade && <div className='body/b2 base/black'>{member.grade}</div>}
            </div>
            <div className='body/b2 base/black'>{maskedMobile}</div>
        </div>
    );

    const unavailableBody = member && (
        <div style={{ display: "flex", flexDirection: "column", gap: 32, padding: 'var(--space20) var(--space16)' }}>
            {userSection}
            <div style={{ display: "flex", justifyContent: "center" }}>
                <SolidBtn
                    sementic='default'
                    type='solid'
                    icon={false}
                    styles={{ container: { width: 200, padding: 'var(--space16)', boxSizing: 'border-box' } }}
                    onClick={() => { setIsOpen(false); navigate('/explore'); }}
                >
                    수업 예약하기
                </SolidBtn>
            </div>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                <Warning width={16} height={16} fill="var(--secondarys400)" />
                <div className='body/b2 secondary/s500' style={{ textAlign: "left" }}>오늘 예약이 없어 지금은 바코드를 사용할 수 없어요</div>
            </div>
        </div>
    );

    const barcodeBody = member && (
        <div onClick={() => { setIsOpenBarcodeWithNameFullScreenModal(true); }} style={{ padding: "var(--space20) 0" }}>
            <div style={{ paddingInline: 'var(--space16)' }}>{userSection}</div>
            <div style={{ overflowX: 'hidden' }}>
                <img style={{ width: "130%", height: 92, marginLeft: '-15%', paddingBlock: "var(--space16)" }} src={member.barcodeImageUrl} alt="barcode" />
            </div>
            <div style={{ display: "flex", borderRadius: "5px", gap: "8px", alignItems: "center", paddingInline: 'var(--space16)', paddingTop: 16 }}>
                <Warning width={16} height={16} fill="var(--secondarys400)" />
                <div className='body/b2 secondary/s500' style={{ textAlign: "left" }}>체크인할 때 컨시어지에 바코드를 보여주세요</div>
            </div>
        </div>
    );

    const errorBody = (
        <div style={{ display: "flex", gap: 8, alignItems: "center", justifyContent: "center", padding: 'var(--space20) var(--space16)' }}>
            <Warning width={16} height={16} fill="var(--secondarys400)" />
            <div className='body/b2 secondary/s500' style={{ textAlign: "left" }}>정보를 불러오지 못했어요. 다시 시도해 주세요</div>
        </div>
    );

    const whiteCardBody = isError || !member
        ? errorBody
        : hasReservationToday === true
            ? barcodeBody
            : unavailableBody;

    return <>
        <Modal
            open={isOpen}
            closeIcon={false}
            centered
            footer={null}
            width={335}
            mask={false}
            styles={{ wrapper: { pointerEvents: 'none' }, body: { width: '100%' }, content: { padding: 0, backgroundColor: "#FFFFFF", borderRadius: 'var(--radius4)', pointerEvents: 'auto' } }}
            onCancel={() => setIsOpen(false)}
        >
            {whiteCardBody}
        </Modal>
        {member && <BarcodeWithNameFullScreen isOpen={isOpenBarcodeWithNameFullScreenModal} setIsOpen={setIsOpenBarcodeWithNameFullScreenModal} member={member} />}
    </>
}

export { BarcodeBasicModal }
